export enum AdminOrganisationAction {
    DELETE = 'DELETE',
    TRANSFER = 'TRANSFER',
    LEAVE = 'LEAVE'
}
